export default {
    "cities":[
        {
            "name": "New York City",
            "data": "19,768,458",
            "extra": "NY, NJ, CT, PA"
        },
        {
          "name": "Los Angeles",
          "data": "12,997,353",
          "extra": "CA"
        },
        {
          "name": "Chicago",
          "data": "9,509,934",
          "extra": "IL, IN, WI"
        },
        {
          "name": "Dallas",
          "data": "7,759,615",
          "extra": "TX"  
        },
        {
          "name": "Houston",
          "data": "7,206,841",
          "extra": "TX"  
        },
        {
          "name": "Washington D.C.",
          "data": "6,356,434",
          "extra": "DC, MD, VA, WV, PA"  
        },
        {
          "name": "Philadelphia",
          "data": "6,228,601",
          "extra": "PA, NJ, DE, MD"  
        },
        {
          "name": "Atlanta",
          "data": "6,114,050",
          "extra": "GA, AL"  
        },
        {
          "name": "Miami",
          "data": "6,091,747",
          "extra": "FL"  
        },
        {
          "name": "Phoenix",
          "data": "4,946,145",
          "extra": "AZ"  
        },
        {
          "name": "Boston",
          "data": "4,899,932",
          "extra": "MA, RI, NH, CT"  
        },
        {
          "name": "Riverside",
          "data": "4,653,105",
          "extra": "CA"  
        },
        {
          "name": "San Francisco",
          "data": "4,623,264",
          "extra": "CA"  
        },
        {
          "name": "Detroit",
          "data": "4,365,205",
          "extra": "MI"  
        },
        {
          "name": "Seattle",
          "data": "4,011,553",
          "extra": "WA"  
        },
        {
          "name": "Minneapolis",
          "data": "3,690,512",
          "extra": "MN, WI"  
        },
        {
          "name": "San Diego",
          "data": "3,286,069",
          "extra": "CA"  
        },
        {
          "name": "Tampa",
          "data": "3,219,514",
          "extra": "FL"  
        },
        {
          "name": "Denver",
          "data": "2,972,566",
          "extra": "CO"  
        },
        {
          "name": "Baltimore",
          "data": "2,838,327",
          "extra": "DC, MD, VA, WV, PA"  
        },
        {
          "name": "St. Louis",
          "data": "2,809,299",
          "extra": "MO, IL"  
        },
        {
          "name": "Charlotte",
          "data": "2,701,046",
          "extra": "NC, SC"  
        },
        {
          "name": "Orlando",
          "data": "2,691,925",
          "extra": "FL"  
        },
        {
          "name": "San Antonio",
          "data": "2,601,788",
          "extra": "TX"  
        },
        {
          "name": "Portland",
          "data": "2,511,612",
          "extra": "OR, WA"  
        },
        {
          "name": "Sacramento",
          "data": "2,411,428",
          "extra": "CA"  
        },
        {
          "name": "Pittsburgh",
          "data": "2,353,538",
          "extra": "PA, OH, WV"  
        },
        {
          "name": "Austin",
          "data": "2,352,426",
          "extra": "TX"  
        },
        {
          "name": "Las Vegas",
          "data": "2,292,476",
          "extra": "NV, AZ"  
        },
        {
          "name": "Cincinnati",
          "data": "2,259,935",
          "extra": "OH, KY, IN"  
        },
        {
          "name": "Kansas City",
          "data": "2,199,490",
          "extra": "MO, KS"  
        },
        {
          "name": "Columbus",
          "data": "2,151,017",
          "extra": "OH"  
        },
        {
          "name": "Indianapolis",
          "data": "2,126,804",
          "extra": "IN"  
        },
        {
          "name": "Cleveland",
          "data": "2,075,662",
          "extra": "OH"  
        },
        {
          "name": "Nashville",
          "data": "2,012,476",
          "extra": "TN"  
        },
        {
          "name": "San Jose",
          "data": "1,952,185",
          "extra": "CA"  
        },
        {
          "name": "Norfolk",
          "data": "1,803,328",
          "extra": "VA, NC"  
        },
        {
          "name": "Providence",
          "data": "1,675,774",
          "extra": "MA, RI, NH, CT"  
        },
        {
          "name": "Jacksonville",
          "data": "1,637,666",
          "extra": "FL, GA"  
        },
        {
          "name": "Milwaukee",
          "data": "1,566,487",
          "extra": "WI"  
        },
        {
          "name": "Raleigh",
          "data": "1,448,411",
          "extra": "NC"  
        },
        {
          "name": "Oklahoma City",
          "data": "1,441,647",
          "extra": "OK"  
        },
        {
          "name": "Memphis",
          "data": "1,336,103",
          "extra": "TN, MS, AR"  
        },
        {
          "name": "Richmond",
          "data": "1,324,062",
          "extra": "VA"  
        },
        {
          "name": "Louisville",
          "data": "1,284,566",
          "extra": "KY, IN"  
        },
        {
          "name": "Salt Lake City",
          "data": "1,263,061",
          "extra": "UT"  
        },
        {
          "name": "New Orleans",
          "data": "1,261,726",
          "extra": "LA, MS"  
        },
        {
          "name": "Hartford",
          "data": "1,211,906",
          "extra": "CT"  
        },
        {
          "name": "Buffalo",
          "data": "1,162,336",
          "extra": "NY"  
        },
        {
          "name": "Birmingham",
          "data": "1,114,262",
          "extra": "AL"  
        }
    ],
    question: "Which city has a larger population?"
}